import { Controller } from "@hotwired/stimulus"

// Toggles contact status via fetch and updates the button text.
export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    const link = event.currentTarget
    const url = link.href || link.dataset.url

    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.save_status && data.contact_id > 0) {
        const btn = document.getElementById('contact_status_button_' + data.contact_id)
        if (btn) btn.innerHTML = data.contact_status + ' <i class="fa fa-repeat"></i>'
      }
    })
  }
}
